import React, { useCallback, useEffect, useState } from "react";
import Styles from "./job.module.scss";
import tick from "../../../../../images/tick.svg";
import Upload from "../../../../../images/upload.svg";
import { AutoComplete, Input, Select, notification } from "antd";
import Cross from "../../../../../images/cross.svg";
import BlueClose from "../../../../../images/bluecross.svg";

import { functionService } from "../../../../../lib/functions";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import TeamRadioSelect from "./teamRadio";
const expectedStartoptions = [
    {
        label: "Immediately",
        value: "Immediately",
    },
    {
        label: "In 1 to 2 weeks",
        value: "In 1 to 2 weeks",
    },
    {
        label: "In 2 to 4 weeks",
        value: "In 2 to 4 weeks",
    },
    {
        label: "More than 1 month from now",
        value: "More than 1 month from now",
    },
];
const constants = [
    {
        name: "Web Platform",
        value: "Web Platform",
    },
    {
        name: "Mobile App",
        value: "Mobile App",
    },
    {
        name: "Integration",
        value: "Integration",
    },
    {
        name: "Marketing Website",
        value: "Marketing Website",
    },
    {
        name: "Prototype",
        value: "Prototype",
    },
];
const arr = [
    "Web Platform",
    "Mobile App",
    "Prototype",
    "Marketing Website",
    "Integration",
];
const Jobrole = () => {
    const Text = styled.p`
        cursor: pointer;
        width: fit-content;
        border-bottom: 1px solid
            ${(props) => (props.isOpen ? "#1B49EA" : "black")};
        color: ${(props) => (props.isOpen ? "#1B49EA" : "black")};
        margin: 20px 0;
        font-weight: 500;
    `;
    const [expectedStart, setExpectedStart] = useState();
    const [JDName, setJDName] = useState();
    const [jdurl, setjdurl] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenOther, setIsOpenOther] = useState(false);

    const [autocompleteSkill, setAutoCompleteSkill] = useState();
    const [optionJobProfile, setoptionJobProfile] = useState([]);
    const [selectedRole, setSelectedRole] = useState([]);
    const [skillData, setSkillData] = useState([]);
    const [inputvalue, setInputValue] = useState(undefined);
    const [selectedValue, setSelectedValue] = useState("");
    const [isSelected, setIsSelected] = useState(false);

    let { search_id } = useParams();

    const handleProjectDuration = (val) => {
        setExpectedStart(val);
    };
    const uploadHandler = async (event) => {
        if (event.target.files?.length) {
            const fileData = event.target.files[0];

            if (fileData.size >= 2 * 1000 * 1000) {
                notification["error"]({
                    message: "File size exceeded",

                    description: `File size can't be more than 2 MB!`,
                });
            } else if (
                fileData.name.toLowerCase().endsWith(".pdf") ||
                fileData.name.toLowerCase().endsWith(".doc") ||
                fileData.name.toLowerCase().endsWith(".docx")
            ) {
                let res = await functionService.uploadFile(fileData);

                if (res.status === true) {
                    setjdurl(res?.response?.data?.location);

                    setJDName(fileData?.name);
                }
            } else {
                // notification["error"]({
                //     message: "Unsupported file format",
                //     description: `Please select either doc file or pdf file!`,
                // });
            }
        }
    };
    const onSearch = async (searchText) => {
        if (searchText?.length == 0) {
            setoptionJobProfile([]);
        } else {
            let res = await functionService.post(
                `recruiter/role-suggestion?name=${searchText}`
            );
            console.log("__________", res);
            let suggestionsresult =
                res?.response?.data?.length <= 0
                    ? []
                    : res?.response?.data?.map((item) => ({
                          value: item,
                      }));
            setoptionJobProfile(!searchText ? [] : suggestionsresult);
        }
    };
    const onSelectionAutocomplete = (item) => {
        const index = selectedRole?.findIndex((t) => t === item);
        if (index < 0) {
            setSelectedRole([...selectedRole, item]);

            if (
                !selectedRole.includes(item) &&
                skillData?.findIndex((i) => i === item) === -1
            ) {
                setSkillData((prev) => {
                    return [...prev, item];
                });
            }
        }
    };
    const getCandidateSearchData = async () => {
        const response = await functionService.post(
            "recruiter/getcandidatedetails",
            {
                search_id: search_id,
            }
        );
        console.log("__________", response?.response?.data?.data);
        setExpectedStart(response?.response?.data?.data?.expected_start);
        setSkillData(response?.response?.data?.data?.project_recommeded_role);
        setSelectedRole(
            response?.response?.data?.data?.project_recommeded_role
        );
        setSelectedValue(response?.response?.data?.data?.project_type);
        setJDName(
            response?.response?.data?.data?.requirement_doc
                ? decodeURIComponent(
                      response?.response?.data?.data?.requirement_doc.substring(
                          response?.response?.data?.data?.requirement_doc.lastIndexOf(
                              "/"
                          ) + 1
                      )
                  )
                : ""
        );
        setjdurl(response?.response?.data?.data?.requirement_doc)
    };
    const onSelection = useCallback(
        (item) => {
            const index = selectedRole?.findIndex((t) => t === item);
            if (index < 0) {
                setSelectedRole([...selectedRole, item]);
                if (
                    !selectedRole.includes(item) &&
                    skillData?.findIndex((i) => i === item) === -1
                ) {
                    setSkillData((prev) => {
                        return [...prev, item];
                    });
                }
            } else {
                const selectedCopy = Array.from(selectedRole);
                selectedCopy?.splice(index, 1);
                setSelectedRole([...selectedCopy]);
                const skillInd = skillData.findIndex((i) => i === item);
                skillData.splice(skillInd, 1);
                setSkillData([...skillData]);
            }
        },
        [selectedRole, skillData]
    );
    console.log("__________", skillData);
    const handleChange = (val) => {
        setSelectedValue((prev) => (prev === val ? "" : val));
        setInputValue("");
    };
    const handleInputChange = (val) => {
        if (selectedValue.trim().length > 0) {
            setSelectedValue("");
        }

        setInputValue(val);
    };

    useEffect(() => {
        if (search_id) {
            getCandidateSearchData(search_id);
        }
    }, [search_id]);
    return (
        <div className={Styles.complete_container}>
            <p className={Styles.heading}>Search Candidate</p>
            <div className={Styles.container}>
                <p>What can we help you with?</p>
                <div className={Styles.box}>
                    Hire dedicated development team
                    <img src={tick} alt="" />
                </div>
            </div>
            <div className={Styles.container}>
                <p>What will this team be building?</p>
                <div
                    className={Styles.input_styles}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "10px",
                        maxWidth: "500px",
                    }}
                >
                    {constants.map((item) => {
                        return (
                            <TeamRadioSelect
                                item={item}
                                setIsSelected={setIsSelected}
                                selectedValue={selectedValue}
                                handleChange={handleChange}
                            />
                        );
                    })}
                </div>
                <Text isOpen={isOpenOther} onClick={() => setIsOpenOther(!isOpenOther)}>
                    other
                </Text>
                {isOpenOther && (
                    <div className={`${Styles.input} ${Styles.input_styles}`}>
                        <Input
                            placeholder="Enter your project type"
                            onChange={(e) => handleInputChange(e.target.value)}
                            value={inputvalue}
                        />
                    </div>
                )}
                <p>Project Duration</p>
                <div className={`${Styles.select} ${Styles.modify_select}`}>
                    <Select
                        defaultValue="Select duration"
                        style={{ width: 120 }}
                        value={expectedStart}
                        onChange={handleProjectDuration}
                        options={expectedStartoptions}
                    />
                </div>
            </div>
            <div className={Styles.container}>
                <p>Recommended role for your project</p>
                <div className={Styles.skill_wrapper}>
                    {skillData &&
                        skillData?.map((item, i) => {
                            return (
                                <div
                                    className={
                                        selectedRole.includes(item) &&
                                        Styles.highlight_skill
                                    }
                                    onClick={() => {
                                        onSelection(item);
                                    }}
                                >
                                    {item}
                                    {selectedRole.includes(item) && (
                                        <img
                                            alt=""
                                            className={Styles.close_icon}
                                            src={BlueClose}
                                        />
                                    )}
                                </div>
                            );
                        })}
                </div>

                <Text isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
                    Add More
                </Text>
                {isOpen && (
                    <div className={Styles.autocomplete}>
                        <AutoComplete
                            style={{
                                width: 300,
                                height: 40,
                            }}
                            placeholder='Search and add the role'
                            value={autocompleteSkill}
                            onSearch={onSearch}
                            options={optionJobProfile}
                            onSelect={(val, option) => {
                                onSelectionAutocomplete(val);
                                setAutoCompleteSkill("");
                            }}
                            onChange={(e) => setAutoCompleteSkill(e)}
                        />
                    </div>
                )}
            </div>

            <div
                className={`${Styles.left_right_container} ${Styles.container}`}
            >
                <div className={Styles.left_container}>
                    <div>
                        <p className={Styles.bold_text}>Expected start date</p>
                        <div className={Styles.select}>
                            <Select
                                defaultValue="Select duration"
                                style={{ width: 120 }}
                                value={expectedStart}
                                onChange={handleProjectDuration}
                                options={expectedStartoptions}
                            />
                        </div>
                    </div>
                    <div>
                        <p className={Styles.bold_text}>Requirement document</p>
                        <div>
                            {JDName ? (
                                <div
                                    className={Styles.upload_wrapper}
                                    style={{ fontWeight: 700 }}
                                    onClick={()=>window.open(`${jdurl}`)}
                                >
                                    {JDName}
                                    <img
                                        style={{ marginLeft: "10px" }}
                                        onClick={() => {
                                            setJDName(null);
                                            setjdurl(null);
                                        }}
                                        width={12}
                                        height={12}
                                        src={Cross}
                                        alt=""
                                    />
                                </div>
                            ) : (
                                <div
                                    className={
                                        Styles.expectedStartDateContainer
                                    }
                                >
                                    <label
                                        for="upload"
                                        className={Styles.upload_wrapper}
                                    >
                                        <input
                                            id="upload"
                                            // style={{ padding: "20px" }}
                                            hidden
                                            type="file"
                                            accept=".doc, .docx, .pdf"
                                            onChange={uploadHandler}
                                        />
                                        <div
                                            style={{
                                                display: "Flex",
                                                flexDirection: "column",
                                                justifyContent: "flex-start",
                                            }}
                                        >
                                            <p
                                                className={Styles.upload_text}
                                                style={{
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                    marginTop: "0px",
                                                    marginBottom: "5px",
                                                    color: "#1E2228",
                                                }}
                                            >
                                                {" "}
                                                Upload
                                            </p>
                                            <span
                                                style={{
                                                    fontWeight: 400,
                                                    fontSize: "12px",

                                                    color: "#506D85",
                                                }}
                                            >
                                                {" "}
                                                File format : PDF, Doc, Docx
                                            </span>
                                        </div>
                                        <span
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                background: "#1b49ea",
                                                borderRadius: "8px",
                                                padding: "12px",
                                            }}
                                        >
                                            <img alt="" src={Upload} />
                                        </span>
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${Styles.container} ${Styles.btn_container}`}>
                <button className={Styles.search_btn}>Search Candidate</button>
            </div>
        </div>
    );
};

export default Jobrole;
